import { callApi } from "./Api";
import { setReportWebSiteId } from "./Insights";

export const GET_CLIENTS_TABLE = "GET_CLIENTS_TABLE";
export const GET_CLIENT_SITES = "GET_CLIENT_SITES";
export const GET_ALL_CLIENTS_TABLE = "GET_ALL_CLIENT_TABLE";
export const INVITATION_CLIENT = "INVITATION_CLIENT";
export const GET_INDUSTRY_OPTIONS = "GET_INDUSTRY_OPTIONS";
export const SEND_INVITATION = "SEND_INVITATION";
export const TIER_OPTIONS = "TIER_OPTIONS";
export const ACCOUNT_MANAGER = "ACCOUNT_MANAGER";
export const CLIENT_OPTIONS = "CLIENT_OPTIONS";
export const ROLLBACK_STATUS = "ROLLBACK_STATUS";
export const SEARCH_CLIENTS = "SEARCH_CLIENTS";
export const CLIENT_NAME = "CLIENT_NAME";
export const CREATE_CLIENT_PROFILE = "CREATE_CLIENT_PROFILE";
export const ROLLBACK_PROFILE_STATUS = "ROLLBACK_PROFILE_STATUS"; // rollback profile ajax status
export const TEAM_MEMBER = "TEAM_MEMBER";
export const BUSINESS_UNIT_OPTIONS = "BUSINESS_UNIT_OPTIONS";
export const INVITE_BUSINESS_MEMBER = "INVITE_BUSINESS_MEMBER";
export const CLIENT_USERS = "CLIENT_USERS";
export const GET_BUSINESS_UNIT_TEAM_MEMBER = "GET_BUSINESS_UNIT_TEAM_MEMBER";
export const INVITATE_BUSINESS_UNIT_MEMBER = "INVITATE_BUSINESS_UNIT_MEMBER";
export const GET_CLIENT_TAGS = "GET_CLIENT_TAGS";
// INSIGHTS_STANDARD_CONFIG
export const INSIGHTS_STANDARD_CONFIG = "INSIGHTS_STANDARD_CONFIG";
export const GET_INSIGHTS_STANDARD_CONFIG = "GET_INSIGHTS_STANDARD_CONFIG";
export const RESET_STANDARD_CONFIG = "RESET_STANDARD_CONFIG";

// below is edit page's type
export const GET_CLIENT_PROFILE = "GET_CLIENT_PROFILE";
export const UPDATE_CLIENT_PROFILE = "UPDATE_CLIENT_PROFILE";
export const SUSPEND_AND_REACTIVATE = "SUSPEND_AND_REACTIVATE";

export const rollbackStatus = () => ({ type: ROLLBACK_STATUS, value: false });
export const rollbackProfileStatus = () => ({ type: ROLLBACK_PROFILE_STATUS });
export const resetStandardConfig = () => ({ type: RESET_STANDARD_CONFIG });

// for edit/Business-Units page
export const BUSINESS_UNITS_LIST = "BUSINESS_UNITS_LIST";

export const get_client_options = () => (dispatch, getState) => {
  let url = `roles/client-options`;
  callApi(dispatch, getState, CLIENT_OPTIONS, url);
};

export const getAccountManage = () => (dispatch, getState) => {
  let url = `commons/account-manager-options`;
  callApi(dispatch, getState, ACCOUNT_MANAGER, url);
};

export const getTierOptions = () => (dispatch, getState) => {
  let url = `commons/subscription-tier-options`;
  callApi(dispatch, getState, TIER_OPTIONS, url);
};

// for client search api and get client table list
export const getClientsTable = obj => (dispatch, getState) => {
  let url = `clients/search`;
  callApi(dispatch, getState, GET_CLIENTS_TABLE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const getAllClientsTable = obj => (dispatch, getState) => {
  let url = `clients/search`;
  callApi(dispatch, getState, GET_ALL_CLIENTS_TABLE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const getIndustryOptions = () => (dispatch, getState) => {
  let url = `commons/industry-options`;
  callApi(dispatch, getState, GET_INDUSTRY_OPTIONS, url);
};

export const invitation_client = obj => (dispatch, getState) => {
  let url = `invitations/client`;
  callApi(dispatch, getState, GET_CLIENTS_TABLE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const inviteBusinessMember = obj => (dispatch, getState) => {
  let url = `invitations/client-to-business-unit-member`;
  callApi(dispatch, getState, INVITE_BUSINESS_MEMBER, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const send_invitation = obj => (dispatch, getState) => {
  let url = `invitations/client`;

  callApi(dispatch, getState, SEND_INVITATION, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const search_clients = obj => (dispatch, getState) => {
  let url = `clients`;
  callApi(dispatch, getState, SEARCH_CLIENTS, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};
export const getClientName = () => (dispatch, getState) => {
  let url = `commons/client-options`;
  callApi(dispatch, getState, CLIENT_NAME, url);
};

export const getClientSites = (cid, useLocalWebsiteId) => (dispatch, getState) => {
  const url = `clients/${cid}/site-options`;
  callApi(
    dispatch,
    getState,
    GET_CLIENT_SITES,
    url,
    {},
    {
      success: (data = []) => {
        const localWebsiteId = window.localStorage.getItem('__websiteId__');
        let hasLocalId = false;
        data.forEach(it => {
          if ((localWebsiteId !== undefined) && (+it.value === +localWebsiteId)) {
            hasLocalId = true;
          }
        });
        const dataWebsiteId = data[0] && data[0].value;
        const finalWebsiteId = (useLocalWebsiteId && hasLocalId) ? (+localWebsiteId || dataWebsiteId) : dataWebsiteId;
        if (finalWebsiteId) {
          dispatch(setReportWebSiteId(finalWebsiteId));
        }
      },
    },
  );
};

export const createClientProfile = obj => (dispatch, getState) => {
  const url = `clients`;
  // localStorage.setItem('createClientStartTime', new Date().getTime())
  callApi(dispatch, getState, CREATE_CLIENT_PROFILE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const createClientBusinessUnit = (obj, clientId) => (
  dispatch,
  getState,
) => {
  const url = `clients/${clientId}/business-units`;
  if (
    obj.accountManagerUserIds &&
    obj.accountManagerUserIds.length > 0 &&
    obj.accountManagerUserIds[0] === ""
  ) {
    obj.accountManagerUserIds = undefined;
  }
  callApi(dispatch, getState, CREATE_CLIENT_PROFILE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

// get data for `assign business assign to`
export const getTeamMember = id => (dispatch, getState) => {
  let url;
  if (
    /^(system administrator|account manager|administrator|team member)/gi.test(
      getState().app.roleName,
    )
  ) {
    url = `clients/${id}/team-member-options`;
  } else {
    url = `commons/team-member-options`;
  }
  callApi(dispatch, getState, TEAM_MEMBER, url);
};

// business unit options
export const getBusinessUnitOptions = () => (dispatch, getState) => {
  let url = `commons/business-unit-options`;

  callApi(dispatch, getState, BUSINESS_UNIT_OPTIONS, url);
};

// below is edit page's action
export const getClientProfile = id => (dispatch, getState) => {
  let url = `clients/${id}`;

  callApi(
    dispatch,
    getState,
    GET_CLIENT_PROFILE,
    url,
    {},
    {
      failure: () => {
        window.location.href = "/dashboard";
      },
    },
  );
};

export const updateClientProfile = (id, obj) => (dispatch, getState) => {
  let url = `clients/${id}`;

  callApi(dispatch, getState, UPDATE_CLIENT_PROFILE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const suspendAndReactivate = (clientId, status) => (
  dispatch,
  getState,
) => {
  let url;
  if (
    /^(system administrator|account manager|administrator|team member)/gi.test(
      getState().app.roleName,
    )
  ) {
    url = `clients/${clientId}/${status}`;
  }

  callApi(dispatch, getState, SUSPEND_AND_REACTIVATE, url, {
    method: "POST",
  });
};

// for edit/Business-Units page
export const getClientBusiness = id => (dispatch, getState) => {
  let url = `clients/${id}/business-units`;

  callApi(dispatch, getState, BUSINESS_UNITS_LIST, url);
};

export const getClientUsers = (cid, req) => (dispatch, getState) => {
  const url = `clients/${cid}/users`;

  callApi(dispatch, getState, CLIENT_USERS, url, {
    method: "POST",
    body: JSON.stringify(req),
  });
};

export const getBusinessUnitTeamMembers = (clientId, businessId) => (
  dispatch,
  getState,
) => {
  const url = `clients/${clientId}/business-units/${businessId}/team-members`;

  callApi(dispatch, getState, GET_BUSINESS_UNIT_TEAM_MEMBER, url);
};

export const sendInviteBusinessUnitMember = obj => (dispatch, getState) => {
  let url;
  if (
    /^\/clients\/edit\/Client-Team-Members/.test(
      getState().routing.location.pathname,
    )
  ) {
    url = `invitations/client-to-business-unit-member`;
  } else {
    url = `invitations/internal-to-business-unit-member`;
  }

  callApi(dispatch, getState, INVITATE_BUSINESS_UNIT_MEMBER, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const getClientTags = clientId => (dispatch, getState) => {
  const url = `clients/${clientId}/tags`;
  callApi(dispatch, getState, GET_CLIENT_TAGS, url);
};

//INSIGHTS_STANDARD_CONFIG
export const configInsightsStandard = (id, obj) => (dispatch, getState) => {
  const url = `clients/${id}/insights-standard-config`;
  callApi(dispatch, getState, INSIGHTS_STANDARD_CONFIG, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};
// GET INSIGHTS STANDARD CONFIG
export const getConfigInsightsStandard = id => (dispatch, getState) => {
  const url = `clients/${id}/insights-standard-config`;
  callApi(dispatch, getState, GET_INSIGHTS_STANDARD_CONFIG, url);
};



// WEBPACK FOOTER //
// ./src/actions/Clients.js